(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection"] && !window.DesignMode) return;
  try {
    

function addfl(){
	this.$owlItems.removeClass('first last');
	this.$owlItems.eq(this.currentItem).addClass('first');
	this.$owlItems.eq(this.currentItem + (this.owl.visibleItems.length - 1)).addClass('last');
}

//======================featured collection slider======================//
var topsliders = document.getElementById('featured_products_slider');
var topowl2 = $("#featured_products_slider");
$(topowl2).each(function (index) {
  $(this).owlCarousel({
    items : 5, //10 items above 1000px browser width
    itemsDesktop : [1269,4], //5 items between 1000px and 901px
    itemsDesktopSmall : [989,3], // betweem 900px and 601px
    itemsTablet: [749,3], //2 items between 600 and 0
    itemsMobile : [479,2], // itemsMobile disabled - inherit from itemsTablet option
	afterAction: addfl
	
  });

  $(".featured_next").click(function(){
    $(topowl2).trigger('owl.next');
  });
  $(".featured_prev").click(function(){
    $(topowl2).trigger('owl.prev');
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quotes"] && !window.DesignMode) return;
  try {
    

	  var reviewsliders = document.getElementById('reviews_review_slider');
      var reviewowl = $("#reviews_review_slider");
      $(reviewowl).each(function (index) {
          $(this).owlCarousel({
			  pagination: !0,
        	  navigation: !1,
			  autoPlay: false,
              items : 1, //10 items above 1000px browser width
			  itemsDesktop : [1280,1], //5 items between 1000px and 901px
              itemsDesktopSmall : [990,1], // betweem 900px and 601px
              itemsTablet: [600,1], //2 items between 600 and 0
              itemsMobile : [480,1] // itemsMobile disabled - inherit from itemsTablet option
          });

          $(".reviews_next").click(function(){
              $(reviewowl).trigger('owl.next');
          });
          $(".reviews_prev").click(function(){
              $(reviewowl).trigger('owl.prev');
          });
   	  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related"]) return;
  try {
    
 
    var relatedowl = $("#related_products_slider");
    relatedowl.owlCarousel({
        items : 4 , //10 items above 1000px browser width
        itemsDesktop : [1269,4], //5 items between 1000px and 901px
        itemsDesktopSmall : [989,3], // betweem 900px and 601px
        itemsTablet: [600,3], //2 items between 600 and 0
        itemsMobile : [479,2]  // itemsMobile disabled - inherit from itemsTablet option
    });
    $(".related_next").click(function(){
    	relatedowl.trigger('owl.next');
    });
    $(".related_prev").click(function(){
    	relatedowl.trigger('owl.prev');
    });
   
   

  } catch(e) { console.error(e); }
})();

})();
